import { createRequestTypes, action } from "../../utils/reducer";

export const CURRENT_PAGE = createRequestTypes("CURRENT_PAGE");

export const currentPage = {
  success: (data) => action(CURRENT_PAGE.SUCCESS, data),
};


export const SIDEBAR_EXPAND = createRequestTypes("SIDEBAR_EXPAND");

export const sideBarExpand = {
  success: (data) => action(SIDEBAR_EXPAND.SUCCESS, data),
};